





















































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import {
	mapActions,
	mapGetters,
	mapMutations,
	mapState,
} from 'vuex';
import ReservationService from '@/components/ReservationService.vue';
import MarkdownText from '@/components/ui/MarkdownText.vue';
import TransitionExpand from '@/components/TransitionExpand.vue';
import ReservationStepMixin from '@/mixins/reservationStepMixin';
import Quote from '@/models/Quote';
import Reservation from '@/models/Reservation';
import Service from '@/models/Service';
import ReservationStep from '@/types/reservationStep';
import { find } from '@/utilities/helpers';

const Setup = Vue.extend({
	name: 'ReservationServices',
	components: {
		MarkdownText,
		ReservationService,
		TransitionExpand,
	},
	computed: {
		...mapState(['isLoading']),
		...mapState('reservation', ['availableServices', 'reservation']),
		...mapGetters('location', ['settings']),
		...mapGetters('reservation', [
			'hasReservation',
			'hasServices',
			'noServicesOnRate',
			'services',
		]),
	},
	data() {
		return {
			Step: ReservationStep,
		};
	},
	watch: {
		step: {
			handler(value) {
				if (value === this.Step.Services) {
					if (this.noServicesOnRate) {
						this.setStep(this.Step.Payment);
					} else {
						this.loadServices();
					}
				}
			},
			immediate: true,
		},
	},
	methods: {
		...mapMutations('reservation', [
			'addService',
			'removeService',
		]),
		...mapActions('reservation', [
			'getQuotes',
			'getServices',
		]),

		loadServices() {
			// override
		},

		setStep(step: ReservationStep) {
			// override
		},
	},
});

@Component
export default class ReservationServices extends mixins(Setup, ReservationStepMixin) {
	// State
	public availableServices!: Service[];
	public isLoading!: boolean;
	public reservation!: Reservation;

	// Getters
	public hasReservation!: boolean;
	public hasServices!: boolean;
	public settings!: Locations.Settings;
	public noServicesOnRate!: boolean;
	public services!: Service[];

	// Mutations
	public addService!: (service: Service) => void;
	public removeService!: (service: Service) => void;

	// Actions
	public getQuotes!: () => Promise<Quote>;
	public getServices!: () => Promise<Service[]>;

	// Computed
	public get model() {
		return this.services;
	}

	public get serviceTotal(): number {
		return this.services.reduce((carry, service) => carry + +service.price, 0);
	}

	// Methods
	public isSelected(service: Service): boolean {
		const findService = (
			searchValue: Service,
		) => find((item: Service) => searchValue.service === item.service)(this.services);

		return !!findService(service);
	}

	public async loadServices() {
		await this.getServices();

		if (!this.$store.getters['reservation/hasServices']) {
			this.setStep(this.Step.Payment);
		}
	}

	public async onServicesSelect() {
		console.log('Services Selected...');
		this.uxAction();

		try {
			await this.getQuotes();
			if (this.requiresPayment) {
				this.setStep(this.Step.Payment);
			} else {
				this.setStep(this.Step.Summary);
			}
		} catch (errors) {
			// Error
		}
	}

	public get requiresPayment(): boolean {
		return this.reservation.quote.is_prepay;
	}

	public toggleService(service: Service) {
		if (this.isSelected(service)) {
			this.$store.dispatch('googleEvents/editServicesRemoveService', {
				serviceRemoved: service,
			});
			this.removeService(service);
			return;
		}

		this.addService(service);
		this.$store.dispatch('googleEvents/editServicesAddService', {
			serviceAdded: service,
		});
	}

	public uxAction() {
		this.$store.dispatch('googleEvents/clickFinalizeServiceChanges', {
			services: this.reservation.services,
		});
	}
}
